import React from 'react'

import HighlightWords from 'react-highlight-words'

import { makeStyles } from '@material-ui/styles'

import styles from './styles'

const useStyles = makeStyles(styles)

const Highlighter = ({ ...rest }) => {
  const classes = useStyles()

  return <HighlightWords highlightClassName={classes.highlight} {...rest} />
}

export default Highlighter
